<template>
  <div class="include-detail">
    <nav-bar titleText="收入明细" @goBack="goBack" ></nav-bar>
    <div class="nodiv"></div>
    <div class="include-detail-content">
      <div class="title">{{commissionInfo.transactionTypeName}}</div>
      <div class="include-money van-hairline--bottom">+{{ commissionInfo.balance }}</div>
      <div class="info-box">
        <div class="debt-money">
          <div class="left">解债金额</div> 
          <div class="right">¥{{ commissionInfo.balance.toFixed(2) }}</div>
        </div>
        <div class="time">
          <div class="left">时间</div>
          <div class="right">{{ commissionInfo.createTime }}</div>
        </div>
        <div class="orderid">
          <div class="left">订单号</div>
          <div class="right">{{ commissionInfo.relationOrder }}</div>
        </div>
        <div>
          <van-button round type="info" size="large" @click="goBack">返回</van-button>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  name:'commissionIncludeDetail',
  data() {
    return {
      commissionInfo: this.$route.query.commissionInfo
    }
  },
  created() {
    this.getDebtDetail()
  },
  components: {
    navBar,
  },
  methods:{
    goBack() {
      this.$router.go(-1);
    },
    getDebtDetail() {

    },
  },

}
</script>

<style lang="less">
.include-detail {
  padding-top: 88px;
  box-sizing: border-box;
  position: relative;
  .nodiv {
    width: 100%;
    height: 12px;
    background-color: #F5F6F7;
  }
  .include-detail-content {
    margin-top: 12px;
    .title {
      height: 24px;
      font-size: 15px;
      line-height: 24px;
      color: #333333;
      text-align: center;
      padding-top: 36px;
    }
    .include-money {
      height: 42px;
      line-height: 42px;
      font-size: 30px;
      font-weight: 600;
      color: #333333;
      text-align: center;
      padding: 9px 0 36px;
      margin: 0 34px;
    }
    .info-box {
      padding: 36px 33px 0;
    }
    .debt-money,.time,.orderid {
      display: flex;
      flex: 1;
      .left {
        width: 35%;
        height: 24px;
        line-height: 24px;
        font-size: 15px;
        color: #999999;
      }
      .right {
        width: 65%;
        height: 24px;
        line-height: 24px;
        text-align: right;
        font-size: 15px;
        color: #333333;
      }
    } 
    .time {
      margin: 9px 0;
    }
    .van-button--round {
      margin-top: 36px;
    }
    .van-button--info {
      border: 1px solid #666666;
      background-color: #ffffff;
      .van-button__text {
        height: 28px;
        line-height: 28px;
        font-size: 17px;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
</style>